import React, { useEffect, useState } from "react";
import { TabbedForm, FormTab, TextInput, ImageInput, ReferenceInput, ArrayInput, AutocompleteInput, SimpleFormIterator, FormDataConsumer, required, Labeled, BooleanInput, NumberInput, useCreateController, Create } from 'react-admin';
import CustomImageField from "../../Components/CustomImageField";
import { goToWebSite, transform } from "./ResiliationModelUtil";
import { GenericToolbar } from "../GenericStyle";
import { useDataProvider } from 'react-admin';
import { RichTextInput } from "ra-input-rich-text";
import Divider from '@mui/material/Divider';
import { Stack } from '@mui/material';
import { Button } from "@mui/material";
import ImportAddressesDialog from "./ImportAddressesDialog";
import { BasicAddressTable } from "./ResiliationModelShared";
import { CustomRichTextInputToolbar, MyEditorOptions } from "../../Components/CustomRichText/CustomRichTextInput";

export const ResiliationModelCreate = (props) => {
    const dataProvider = useDataProvider();
    const [openImport, setOpenImport] = useState(false);
    const { record } = useCreateController();

    const handleCloseImport = (addressItems) => {

        if (addressItems != null) {

        }
        setOpenImport(false);
    }

    useEffect(() => {
    }, []);

    return (
        <Create {...props} transform={transform}>
            <TabbedForm toolbar={<GenericToolbar />}>
                <FormTab label="Général" sx={{ width: "100%" }}>
                    <TextInput disabled label="Id" source="id" />
                    <BooleanInput source="enabled" label="Activer ?" />
                    <ReferenceInput label="Catégorie" source="resiliationCategory.id" perPage={500} reference="ResiliationCategory" validate={required()} sx={{ width: "50%" }}>
                        <AutocompleteInput optionText="name" sx={{ width: "30%" }} />
                    </ReferenceInput>
                    <TextInput source="name" label="Nom" validate={required()} sx={{ width: "50%" }} />
                    <TextInput source="color" label="Code Couleur" placeholder="#FFFFFF" sx={{ width: "50%" }} />
                    <ImageInput source="logoImage" label="Logo" multiple={false} accept="image/*" >
                        <CustomImageField source="src" title="title" />
                    </ImageInput>
                    <FormDataConsumer>
                        {({ formData, dispatch, ...rest }) => {
                            if (!formData.logoImage) {
                                return (
                                    <div>
                                        <Labeled label="Original article image">
                                            <CustomImageField record={formData} source="logoSrc" title="title" />
                                        </Labeled>
                                    </div>
                                );
                            }
                        }}
                    </FormDataConsumer>
                    {/* <TextInput source="url" label="URL" validate={required()} sx={{ width: "50%" }} /> */}
                    {/* <Divider sx={{ width: "100%" }} component="div" role="presentation">Contenu de la lettre</Divider>
                    <Stack direction="row">
                        <Stack>
                            <TextInput source="letterObject" label="Objet" validate={required()} sx={{ width: "50%" }} />
                            <RichTextInput source="letterBeginContent" label="Début Contenu" validate={required()} />
                            <RichTextInput source="letterBlindedContent" label="Contenu Masqué" validate={required()} />
                            <RichTextInput source="letterEndContent" label="Fin Contenu" validate={required()} />
                        </Stack>
                        <Stack direction="column">
                            <Typography fontWeight={700} sx={{ minWidth: "300px" }}>
                                Liste des variables
                            </Typography>
                            <ul>
                                <li>
                                    Date de l'envoi: {"${date}"}
                                </li>
                                <li>
                                    Prénom du client: {"${firstName}"}
                                </li>
                                <li>
                                    Nom du client: {"${lastName}"}
                                </li>
                                <li>
                                    Numéro de client: {"${clientNumber}"}
                                </li>
                            </ul>
                        </Stack>
                    </Stack> */}
                    <Divider sx={{ width: "100%" }} component="div" role="presentation">Informations additionnelles</Divider>
                    <BooleanInput source="isExample" label="Liste exemples" />
                    <Divider sx={{ width: "100%" }} component="div" role="presentation">Numéro client</Divider>
                    <Stack direction="row" justifyContent="start" alignItems="center" spacing="20px" sx={{ width: "100%" }}>
                        <BooleanInput source="needClientNumber" label="Besoin numéro client" />
                    </Stack>
                    <Stack direction="row" justifyContent="start" alignItems="center" spacing="20px" sx={{ width: "100%" }}>
                        <TextInput source="tooltip" label="Tooltip du champ numéro client" sx={{ width: "45%" }} />
                    </Stack>
                    <Stack direction="row" justifyContent="start" alignItems="center" spacing="20px" sx={{ width: "100%" }}>
                        <TextInput source="clientNumberPlaceholder" label="Placeholder du champ numéro client" sx={{ width: "45%" }} />
                        <TextInput source="clientNumberTitle" label="Titre du champ numéro client" sx={{ width: "45%" }} />
                    </Stack>
                    <Divider sx={{ width: "100%" }} component="div" role="presentation">Adresse de résiliation</Divider>
                    <Stack direction="row" justifyContent="start" alignItems="center" spacing="20px" sx={{ width: "100%" }}>
                        <TextInput source="resiliationAddressTitle" label="Titre du champ addresse de résiliation" sx={{ width: "45%" }} />
                        <TextInput source="resiliationAddressTooltip" label="Contenu du tooltip de l'adresse de résiliation" sx={{ width: "45%" }} />
                    </Stack>
                    <Divider sx={{ width: "100%" }} component="div" role="presentation">Date de résiliation</Divider>
                    <Stack direction="row" justifyContent="start" alignItems="center" spacing="20px" sx={{ width: "100%" }}>
                        <TextInput source="resiliationDateTooltip" label="Contenu du tooltip de la date de résiliation" sx={{ width: "45%" }} />
                    </Stack>

                </FormTab>
                <FormTab label="URLs" sx={{ width: "100%" }}>
                    <ArrayInput source="resiliationModelUrls" label="URLs">
                        <SimpleFormIterator inline>
                            <NumberInput hidden disabled label="Id" source="id" defaultValue={0} />
                            <TextInput label="Nom de l'url" source="name" />
                            <TextInput label="URL" source="url" />
                            <NumberInput label="Index" source="index" />
                            {/* <NumberInput label="Index" source="index" /> */}
                        </SimpleFormIterator>
                    </ArrayInput>
                </FormTab>
                <FormTab label="Addresses" sx={{ width: "100%" }}>
                    <Stack direction="row">
                        <Button onClick={() => setOpenImport(true)}>Importer</Button>
                        <ImportAddressesDialog open={openImport} handleClose={handleCloseImport} title={"Test"} />
                    </Stack>
                    <BasicAddressTable headers={["Titre", "Ligne Addresse 1", "Ligne Addresse 2", "Ligne Addresse 3", "Ligne Addresse 4", "Ligne Addresse 5", "Ligne Addresse 6"]} rows={record?.resiliationModelAddresses} />
                    {/* <ArrayInput source="resiliationModelAddresses" label="Adresses">
                        <SimpleFormIterator inline>
                            <NumberInput hidden disabled label="Id" source="id" />
                            <TextInput source="title" label="Titre" />
                            <TextInput source="addressLine1" label="Ligne 1 Adresse" />
                            <TextInput source="addressLine2" label="Ligne 2 Adresse" />
                            <TextInput source="addressLine3" label="Ligne 3 Adresse" />
                            <TextInput source="addressLine4" label="Ligne 4 Adresse" />
                            <TextInput source="addressLine5" label="Ligne 5 Adresse" />
                            <TextInput source="addressLine6" label="Ligne 6 Adresse" />
                        </SimpleFormIterator>
                    </ArrayInput> */}
                </FormTab>
                <FormTab label="SEO">
                    <FormDataConsumer>
                        {({ formData, dispatch, ...rest }) => {
                            return (
                                <div>
                                    <Button variant="contained" sx={{
                                        position: 'absolute',
                                        right: '40px'
                                    }} onClick={() => goToWebSite(formData, dataProvider)}>Voir sur le site</Button>
                                </div>
                            )
                        }}
                    </FormDataConsumer>
                    <TextInput source="titleText" label="Titre de l'article" />

                    <RichTextInput editorOptions={MyEditorOptions} toolbar={<CustomRichTextInputToolbar />} source="article" />

                    <TextInput source="metaTitle" label="Meta Title" />
                    <TextInput source="metaDescription" label="Meta Description" sx={{
                        '& .MuiFormControl-root': {
                            width: '700px'
                        }
                    }} />
                    <TextInput source="articleAltTextImage" label="Alt Image article" />
                    <ImageInput source="articleImage" label="Image article" multiple={false} accept="image/*" >
                        <CustomImageField source="src" title="title" />
                    </ImageInput>
                    <FormDataConsumer>
                        {({ formData, dispatch, ...rest }) => {
                            if (!formData.articleImage) {
                                return (
                                    <div>
                                        <Labeled label="Original article image">
                                            <CustomImageField record={formData} source="articleSrcImage" title="title" />
                                        </Labeled>
                                    </div>
                                );
                            }
                        }}
                    </FormDataConsumer>
                </FormTab>
            </TabbedForm>
        </Create>);
};

